<span class="d-none datatable-responsive-d-visible datatable-responsive-label fw-bold me-1">
  {{column.name | messageTranslate}}:
</span>
<span class="text-truncate">{{value}}</span>
